<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Role</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filter" name="filterTable"
                            id="filterInput"
                            type="search"
                            placeholder="Type to search"
                            @keyup.enter="onFilter(filter)" 
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter(filter)"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                    </div>
                </b-form-group>
                <b-button class="mb-3" variant="pgiBtn" name="roleAddBtn" @click="inputRole">Input Role</b-button>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="role" 
                :fields="fields"
                :currentPage="currentPage" 
                :perPage="perPage"
                @filtered="onFiltered"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data role.
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}`">
                            <b-button size="sm" class="table-button edit" v-b-tooltip.hover title="Edit" name="userStaffEditBtn">
                                <i class="fa fa-pencil-square-o"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'master-role',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input:{
                show: 10
            },
            fields: [
                { key: "level", label: "Level", sortable:true},
                { key: "name", label: "Nama Posisi", sortable:true},
                { key: "action", label: "Aksi"}
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            roleAll: [],
            role: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: ''
        }
    }, 
    
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0

            let getRole = this.$axios.get("role/").then(response => {
                this.roleAll = response.data
                this.role = response.data
                this.updateTotalItem()

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getRole]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //-----------------  Fungsi Ambil Data Role ----------------- 
        
        getRole(){
            this.role = this.roleAll
            this.toggleBusy()
            this.updateTotalItem()
        },


        //----------------- Fungsi Pagination, Sorting, dan Filtering -----------------

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onFilter(letters){
            let filteredArray = []
            for (var x of this.roleAll) {
                if (x.name.toLowerCase().includes(letters.toLowerCase())) {
                    filteredArray.push(x)
                }
            }

            this.role = filteredArray
            this.onFiltered(this.role)
        },

        onFiltered(filteredItems){
            this.rows = filteredItems.length
            this.currentPage = 1
            let prevLimit = null
            let limit = null
            this.perPage = this.input.show
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.filter = ""
            this.toggleBusy()
            this.getRole()
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy(){
            if (this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.roleAll.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        inputRole(){
            this.$router.push({path: `${this.$route.path}/input`});
        },

        editRole(id){
            this.$router.push({path: `${this.$route.path}/${id}`});
        }
    },
    created(){
        this.init()
    }
}
</script>
